import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ILongSteelOrderItem } from '../../../../../store/ducks/long-steel-shopping-cart/types';
import { ApplicationState } from '../../../../../store';
import { addSearchedItem as addSearchItemAction } from '../../../../../store/ducks/long-steel-order-item-search/actions';

import {
  Container,
  ContainerErrors,
  SearchedHeader,
  MenuTable,
  ContainerChipsAdded
} from './styles';

import { Chips, Table } from '@gerdau/hefesto-mais-web';
import { Button, Icon } from '@gerdau/hefesto';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import SearchedItemsCodeEnum from './enum/SearchedItemsCodeEnum';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';

interface SearchedListProps {
  searchedItems: ILongSteelOrderItem[];
  foundItens: number;
  notFoundItens: number;
  onRemoveSearchedItem(idx: number): void;
  onAddSearchedItem(items: ILongSteelOrderItem[]): void;
}

interface productTableProps {
  key: number;
  materialCode: string;
  product: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addItems: any;
}

interface chipsProps {
  id: string;
  label: string;
}

interface productErrorProps {
  key: number;
  product: string;
  message: string;
  code?: string;
}

const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
  document.location.pathname
);

const SearchedList: React.FC<SearchedListProps> = ({
  searchedItems,
  onAddSearchedItem
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [dataProducts, setDataProducts] = useState<any>([]);
  const [selectedProducts, setSelectedProducts] = useState<
    ILongSteelOrderItem[]
  >([]);
  const [chipsSelectedProducts, setChipSelectedProducts] = useState<
    chipsProps[]
  >([]);
  const [dataProductsErrors, setDataProductsErrors] = useState<
    productErrorProps[]
  >([]);
  const taggingInfoPreviousScreen = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const chipsRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const columns = [
    {
      title: 'Código do material',
      dataIndex: 'materialCode',
      key: 'materialCode'
    },
    {
      title: 'Produto',
      dataIndex: 'product',
      key: 'product'
    },
    {
      title: 'Adicionar Itens',
      dataIndex: 'addItems',
      key: 'addItems'
    }
  ];

  const rowSelection = {
    onChange: (_: React.Key[], selectedRows: productTableProps[]) => {
      const selectedItens = searchedItems.filter(
        (item: ILongSteelOrderItem, index: number) => {
          const findSelectedItem = selectedRows.find(
            (selectedItem: productTableProps) => selectedItem.key === index
          );
          item.tableId = index;
          return findSelectedItem;
        }
      );

      setSelectedProducts(selectedItens);
    },

    getCheckboxProps: (record: productTableProps) => {
      const product = searchedItems.find(
        (product: ILongSteelOrderItem, index: number) =>
          product.sku === record.materialCode &&
          product.addedToCart &&
          record.key === index
      );
      return { ...(product && { disabled: true, checked: true }) };
    }
  };

  const addAllSelectedItens = () => {
    if (selectedProducts.length) {
      onAddSearchedItem(selectedProducts);
    }
  };

  const sendTaggingProductWithError = (item: productErrorProps) => {
    if (item.code === SearchedItemsCodeEnum.NOT_FOUND) {
      dispatch(
        sendTagging({
          itemName: 'warning:produto_nao_encontrado',
          itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_selecao_produtoNaoEncontrado`,
          screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:Selecao`,
          event: 'click',
          nonInteraction: true,
          filterInfo: `#nmrPdd:${
            shoppingCartState.customerOrder
              ? shoppingCartState.customerOrder
              : 'not_set'
          }#codEmr:${
            shoppingCartState.emitterId
              ? shoppingCartState.emitterId
              : 'not_set'
          }#codRbd:${
            shoppingCartState.receiverId
              ? shoppingCartState.receiverId
              : 'not_set'
          }#tpCod:${item.product}`
        })
      );
    }
  };

  const setUpdateChips = (chips: chipsProps[]) => {
    const updatedChips = chips.map((chip: chipsProps) => chip.id);

    const removeProducts = chipsSelectedProducts.filter(
      (chip) => !updatedChips.includes(chip.id)
    );

    const updatedSearchedItems = searchedItems.map(
      (searchItem: ILongSteelOrderItem, index: number) => {
        const matchRemoveProduct = removeProducts.find(
          (product) =>
            product.id === String(index) &&
            product.label === searchItem.description
        );

        if (matchRemoveProduct) {
          dispatch(
            sendTagging({
              itemName: 'button:exclusao_produto',
              itemDescription: `comprar_acosLongos_${taggingInfoPreviousScreen.itemDescription}_selecao_exclusao_produto`,
              screenName: `LG:Comprar:AcosLongos:${taggingInfoPreviousScreen.screenName}:Selecao`,
              filterInfo: `#codEmr:${
                shoppingCartState.emitterId
                  ? shoppingCartState.emitterId
                  : 'not_set'
              }#codRbd:${
                shoppingCartState.receiverId
                  ? shoppingCartState.receiverId
                  : 'not_set'
              }#codMat:${
                searchItem.sku ? searchItem.sku : searchItem.customerSku
              }#tpCod:${searchItem.sku ? 'cod_gerdau' : 'cod_interno'}
              #flt:not_set`,
              event: 'click',
              product: searchItem.sku ? searchItem.sku : searchItem.customerSku,
              orderCliente: shoppingCartState.customerOrder
                ? shoppingCartState.customerOrder
                : 'not_set'
            })
          );
          return { ...searchItem, addedToCart: false };
        }
        return searchItem;
      }
    );

    dispatch(addSearchItemAction([...updatedSearchedItems]));
  };

  useEffect(() => {
    const products: productTableProps[] = [];
    const productsWithErrors: productErrorProps[] = [];
    const chipsSelectedProducts: chipsProps[] = [];

    searchedItems.forEach((item: ILongSteelOrderItem, index: number) => {
      if (item.addedToCart) {
        chipsSelectedProducts.push({
          id: String(index),
          label: item.description
        });
      }

      if (item.description) {
        products.push({
          key: index,
          materialCode: item.sku,
          product: item.description,
          addItems: !item.addedToCart ? (
            <Button
              name="addItem"
              ariaLabel="addItem"
              variant="tertiary"
              icon={<Icon option="Plus"></Icon>}
              onClick={() => onAddSearchedItem([{ ...item, tableId: index }])}
            >
              Adicionar Item
            </Button>
          ) : (
            <Button
              name="addItem"
              ariaLabel="addItem"
              variant="tertiary"
              disabled
              icon={<Icon option="Check"></Icon>}
            >
              Adicionado
            </Button>
          )
        });
        return;
      }

      productsWithErrors.push({
        key: index,
        product: item.sku,
        message: item.message,
        code: item.code
      });
    });

    if (productsWithErrors.length !== dataProductsErrors.length) {
      const diffLength = productsWithErrors.length - dataProductsErrors.length;
      if (diffLength > 1) {
        productsWithErrors.forEach((product: productErrorProps) =>
          sendTaggingProductWithError(product)
        );
      } else {
        const [item]: productErrorProps[] = productsWithErrors.slice(-1);
        sendTaggingProductWithError(item);
      }
    }

    setDataProducts(products);
    setDataProductsErrors(productsWithErrors);
    setChipSelectedProducts(chipsSelectedProducts);
    if (chipsRef?.current) {
      chipsRef?.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [searchedItems]);

  return (
    <Container>
      {dataProductsErrors.length > 0 && (
        <>
          <header>
            <span>Resultados da busca: </span>
          </header>
          <SearchedHeader>
            <ContainerErrors>
              {dataProductsErrors.map((data: productErrorProps) => (
                <span key={data.key.toString()}>
                  O produto{' '}
                  <span className="danger">
                    {data.product !== '' ? data.product : 'Não identificado'}
                  </span>{' '}
                  {data.code === SearchedItemsCodeEnum.NOT_FOUND
                    ? 'não foi encontrado'
                    : data.message}
                </span>
              ))}
            </ContainerErrors>
          </SearchedHeader>
        </>
      )}
      <MenuTable>
        <Button
          onClick={() => {
            const addedProducts = selectedProducts.map(
              (item) => item.sku || item.customerSku
            );
            dispatch(
              sendTagging({
                screenName,
                event: 'click',
                itemName: 'button:adicionarItensSelecionados',
                itemDescription: `${itemDescription}_adicionarItensSelecionados`,
                filterInfo: `#nmrPdd:${
                  shoppingCartState.customerOrder
                    ? shoppingCartState.customerOrder
                    : 'not_set'
                }#codEmr:${
                  shoppingCartState.emitterId
                    ? shoppingCartState.emitterId
                    : 'not_set'
                }#codRbd:${
                  shoppingCartState.receiverId
                    ? shoppingCartState.receiverId
                    : 'not_set'
                }`,
                product: addedProducts.toString()
              })
            );
            addAllSelectedItens();
          }}
          name="addAllItems"
          ariaLabel="addAllItems"
          variant="secondary"
          disabled={!selectedProducts.length}
        >
          Adicionar itens selecionados
        </Button>
      </MenuTable>
      <Table
        columns={columns}
        rowSelection={rowSelection}
        dataSource={dataProducts}
      />
      {searchedItems.length > 0 && (
        <ContainerChipsAdded ref={chipsRef}>
          <span>Produtos Adicionados: </span>
          <Chips
            type="input"
            chips={chipsSelectedProducts}
            updateChips={setUpdateChips}
          />
        </ContainerChipsAdded>
      )}
    </Container>
  );
};

export default SearchedList;
